
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/navigation-menu/navigation-menu-item.component.js'
      import type { DdsNavigationItemClickEvent } from '../../events/events'
import type { DdsNavigationDropdownOpenEvent } from '../../events/events'
import type { DdsOpenedEvent } from '../../events/events'
import type { DdsClosedEvent } from '../../events/events'
import type { DdsCloseEvent } from '../../events/events'
      export type { DdsNavigationItemClickEvent } from '../../events/events'
export type { DdsNavigationDropdownOpenEvent } from '../../events/events'
export type { DdsOpenedEvent } from '../../events/events'
export type { DdsClosedEvent } from '../../events/events'
export type { DdsCloseEvent } from '../../events/events'

      const tagName = 'dap-ds-navigation-menu-item'

      /**
 * `dap-ds-navigation-menu-item`
 * @summary A navigation menu item that can contain either a simple link or dropdown content.
 * @element dap-ds-navigation-menu-item
 * @title - Navigation Menu Item
 * @group navigation-menu
 *
 * @property {'xs' | 'sm' | 'lg'} size - The size of the popup.
 * @property {boolean} disabled - The disabled state of the popup.
 * @property {boolean} opened - The open state of the popup.
 * @property {'top' | 'right' | 'bottom' | 'left' | 'top-start' | 'top-end' | 'bottom-start' | 'bottom-end' | 'left-start' | 'left-end' | 'right-start' | 'right-end'} placement - The placement of the popup.
 * @property {'absolute' | 'fixed'} floatingStrategy - The floating strategy of the popup.
 * @property {number} offset - The offset of the popup.
 * @property {boolean} sync - Whether the popup should sync its width with the trigger.
 * @property {number | 'auto'} maxHeight - The maximum height of the popup.
 * @property {number | 'auto'} maxWidth - The maximum width of the popup.
 * @property {boolean} hasArrow - Whether the popup has an arrow.
 * @property {boolean} overflow - Whether the popup should overflow.
 * @property {boolean} fullWidth - Whether the popup should take full width of the screen.
 * @property {boolean} exactHref - Whether the navigation item should be active if the href is exactly the same as the activeHref.
 * @property {string} icon - The name of the icon to display in the trigger.
 * @property {string} ariaLabelledBy - The name of the element that labels the navigation dropdown.
 * @property {string} activeHref - The href of the navigation item that is active.
 * @property {string} baseHref - The href of the navigation item. If provided, the navigation item will be active if the href is a substring of the activeHref. It is useful for dropdowns that are not direct children of the navigation menu.
 * @property {boolean} exactHref - Whether the navigation item should be active if the href is exactly the same as the activeHref.
 *
 * @event {{ href: string, event: Event }} dds-navigation-item-click - Fired when a navigation item is clicked.
 * @event {{ item: DapDSNavigationMenuItem }} dds-navigation-dropdown-open - Fired when a navigation dropdown is opened.
 *
 * @slot trigger - The trigger element (link, button, etc.) for this navigation item.
 * @slot title - The title of the navigation item.
 * @slot - The dropdown content (only used if trigger slot is provided).
 *
 * @csspart base - The base part of the navigation item.
 * @csspart trigger - The trigger element part.
 * @csspart content - The dropdown content part.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsNavigationItemClick: 'dds-navigation-item-click' as EventName<DdsNavigationItemClickEvent>,
onDdsNavigationDropdownOpen: 'dds-navigation-dropdown-open' as EventName<DdsNavigationDropdownOpenEvent>,
onDdsOpened: 'dds-opened' as EventName<DdsOpenedEvent>,
onDdsClosed: 'dds-closed' as EventName<DdsClosedEvent>,
onDdsClose: 'dds-close' as EventName<DdsCloseEvent>
        },
        displayName: "DapDSNavigationMenuItem"
      })

      export default reactWrapper
    